<template>
  <table-setting :items="items" :ClickMethods="modifyOperatorGroup"></table-setting>
</template>
<script>
import TableSetting from './components/TableSetting'
export default {
  name: 'modify',
  components: {
    TableSetting
  },
  data () {
    return {
      items: []
    }
  },
  created () {
    if (this.$route.params.id) {
      this.getOperatorGroup()
    } else {
      this.$router.push({ name: 'operator-group-list' })
    }
  },
  methods: {
    async getOperatorGroup () {
      try {
        const res = await this.$axios.operatorGroup.getOperatorGroupData(this.$route.params.id)
        if ('status' in res && res.status === 0) return
        this.items = res
      } catch (error) {
        console.error(error)
      }

    },
    async modifyOperatorGroup (obj, pagedata) {
      const _params = {
        oid: this.$route.params.id,
        ...obj
      }
      pagedata.forEach(it => {
        // _params[it.key] = it.model.join('')
        if (it.key == 'gameset') {
          _params[it.key] = it.model.slice(0, 6).join('')
          _params['settlement'] = it.model.slice(6, 8).join('')
        } else {
          _params[it.key] = it.model.join('')
        }
      })
      try {
        const msg = await this.$axios.operatorGroup.modify(_params)
        if (msg.status === 1) {
          this.$Message.success('已修改');
          this.$router.push({ name: 'operator-group-list' })
        }
      } catch (err) {
        this.$Message.error('请将栏位填写完整');
      }
    }
  }
}
</script>